"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeSleep = void 0;
var IkeSleep = /** @class */ (function () {
    function IkeSleep() {
    }
    /**
     * Wait for duration ms;
     * @param duration Number of ms to wait
     */
    IkeSleep.sleep = function (duration) {
        return new Promise(function (resolve) { return setTimeout(resolve, duration); });
    };
    return IkeSleep;
}());
exports.IkeSleep = IkeSleep;
//# sourceMappingURL=sleep.js.map